export enum QPointDateFormat {
  ShortDateTimeWithSeconds = 'd T',
  ShortDateTime = 'd t',
  ShortDate = 'd',
  LongDate = 'D',
  ShortTime = 't',
  IsoDate = 'y-MM-dd',
  IsoDateTime = 'y-MM-dd HH:mm:ss',
  IsoDateTimeWithSeconds = 's',
  DayOfWeekWithShortDate = 'EEEE, d',
  DayOfWeekShortWithShortDate = 'EEEEEE, d',
  DayOfWeekWithShortDateTime = 'EEEE, d T',
  DayOfWeekShortWithShortDateTime = 'EE d t',
  WrittenMonthWithDayAndYear = 'd. Y',
  DateIntervalShort = "d",
  MonthWithYear = "MMMM yyyy",
  Year = "yyyy"
}
